import ScrollLoader from './ScrollLoader';

export default ScrollLoader;
